import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setActivePage,
  setActiveChildPage,
} from "../../../redux/actions/active-page";
import SearchField from "../../universal/search-content-field/search-content-field.component";
import AddClientModal from "./modals/add-client-modal";
import EditClientModal from "./modals/edit-client-modal";
import DeleteClientModal from "./modals/delete-client-modal";
import {
  sendErrorNotification,
  sendSuccessNotification,
} from "../../universal/notifications/notifications";
import CompaniesTabContainer from "./company-clients";
import PeopleTabContainer from "./person-clients";
import {
  resetActiveClientDisplay,
  resetActiveClientDeletion,
  resetAddSingleClient,
  resetDeleteClientArray,
  resetDeleteSingleClient,
  resetSearchSingleClient,
  resetUpdateSingleClient,
  retrieveCompanyClientsList,
  retrievePersonClientsList,
  changeClientsModal,
  requestDeleteClientArray,
} from "../../../redux/actions/clients";
import { ToastContainer } from "react-toastify";
import { resetFallbackMessage } from "../../../redux/actions/universal";
import TabSelector from "../../library/tab-selector";
import { UpperRow } from "../../library/upper-row";
import { SolidButton } from "../../library/button";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const user = useSelector(
    (state) => state && state.auth && state.auth.user && state.auth.user.id
  );
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const modal = useSelector((state) => state.clients.showModals);

  const updateError = useSelector((state) => state.clients.updateClient.error);
  const updateStatus = useSelector(
    (state) => state.clients.updateClient.status
  );

  const deleteError = useSelector((state) => state.clients.deleteClient.error);
  const deleteStatus = useSelector(
    (state) => state.clients.deleteClient.status
  );

  const addError = useSelector((state) => state.clients.addClient.error);
  const addStatus = useSelector((state) => state.clients.addClient.status);

  const deleteArrayError = useSelector(
    (state) => state.clients.deleteArray.error
  );
  const deleteArrayStatus = useSelector(
    (state) => state.clients.deleteArray.status
  );

  const errorFallbackMessage = useSelector(
    (state) => state.universal.errorNotification
  );
  const successFallbackMessage = useSelector(
    (state) => state.universal.successNotification
  );

  const activeCompany = useSelector(
    (state) => state.activeCompany && state.activeCompany.activeCompany
  );
  const deletions = useSelector((state) => state.clients.deletionArray);

  const deleteLoading = useSelector(
    (state) => state.clients.deleteArray.loading
  );

  const [searchQuery, setSearchQuery] = useState("");

  const selectionTabs = [
    {
      key: "companies",
      title: "Bedriftskunder",
      content: <CompaniesTabContainer />,
    },
    {
      key: "people",
      title: "Personkunder",
      content: <PeopleTabContainer />,
    },
  ];

  useEffect(() => {
    dispatch(setActivePage("clients"));
    dispatch(setActiveChildPage(null));
  });

  const searchLibrary = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    dispatch(resetDeleteClientArray());
    dispatch(resetActiveClientDeletion());
    dispatch(resetUpdateSingleClient());
    dispatch(resetActiveClientDisplay());
    dispatch(resetDeleteSingleClient());
    dispatch(resetSearchSingleClient());
  }, []);

  useEffect(() => {
    if (addStatus && addStatus === "person") {
      sendSuccessNotification("Kunden ble lagt til.");
      dispatch(resetAddSingleClient());
      dispatch(resetSearchSingleClient());
      dispatch(
        retrievePersonClientsList({ companyId: selectedCompany, user: user })
      );
    }

    if (addStatus && addStatus === "company") {
      sendSuccessNotification("Kunden ble lagt til.");
      dispatch(resetAddSingleClient());
      dispatch(resetSearchSingleClient());
      dispatch(
        retrieveCompanyClientsList({ companyId: selectedCompany, user: user })
      );
    }

    if (addError) {
      sendErrorNotification("Kunne ikke legge til kunde.");
      dispatch(resetAddSingleClient());
      dispatch(resetSearchSingleClient());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addStatus, addError]);

  useEffect(() => {
    if (deleteStatus && deleteStatus === "person") {
      sendSuccessNotification("Kunde ble slettet.");
      dispatch(resetDeleteSingleClient());
      dispatch(resetActiveClientDeletion());
      dispatch(resetDeleteClientArray());
      dispatch(
        retrievePersonClientsList({ companyId: selectedCompany, user: user })
      );
    }

    if (deleteStatus && deleteStatus === "company") {
      sendSuccessNotification("Kunde ble slettet.");
      dispatch(resetDeleteSingleClient());
      dispatch(resetActiveClientDeletion());
      dispatch(resetDeleteClientArray());
      dispatch(
        retrieveCompanyClientsList({ companyId: selectedCompany, user: user })
      );
    }

    if (deleteError) {
      sendErrorNotification("Kunne ikke slette kunde.");
      dispatch(resetDeleteSingleClient());
      dispatch(resetActiveClientDeletion());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteStatus, deleteError]);

  useEffect(() => {
    if (deleteArrayError) {
      sendErrorNotification("Kunne ikke slette valgte kunder.");
      dispatch(resetDeleteClientArray());
      dispatch(resetActiveClientDeletion());
      dispatch(
        retrieveCompanyClientsList({ companyId: selectedCompany, user: user })
      );
      dispatch(
        retrievePersonClientsList({ companyId: selectedCompany, user: user })
      );
    }

    if (deleteArrayStatus) {
      sendSuccessNotification("Valgte kunder ble slettet.");
      dispatch(resetDeleteClientArray());
      dispatch(resetActiveClientDeletion());
      dispatch(
        retrieveCompanyClientsList({ companyId: selectedCompany, user: user })
      );
      dispatch(
        retrievePersonClientsList({ companyId: selectedCompany, user: user })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteArrayStatus, deleteArrayError]);

  useEffect(() => {
    if (updateStatus && updateStatus === "person") {
      sendSuccessNotification("Kunden ble oppdatert.");
      dispatch(resetUpdateSingleClient());
      dispatch(resetActiveClientDisplay());
      dispatch(
        retrievePersonClientsList({ companyId: selectedCompany, user: user })
      );
    }

    if (updateStatus && updateStatus === "company") {
      sendSuccessNotification("Kunden ble oppdatert.");
      dispatch(resetUpdateSingleClient());
      dispatch(resetActiveClientDisplay());
      dispatch(
        retrieveCompanyClientsList({ companyId: selectedCompany, user: user })
      );
    }

    if (updateError) {
      sendErrorNotification("Kunne ikke oppdatere kunde.");
      dispatch(resetUpdateSingleClient());
      dispatch(resetActiveClientDisplay());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateStatus, updateError]);

  useEffect(() => {
    if (errorFallbackMessage) {
      sendErrorNotification(errorFallbackMessage);
      dispatch(resetFallbackMessage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorFallbackMessage]);

  useEffect(() => {
    if (successFallbackMessage) {
      sendSuccessNotification(successFallbackMessage);
      dispatch(resetFallbackMessage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successFallbackMessage]);

  const clickAddNewClient = () => {
    if (activeCompany && activeCompany.subscription) {
      dispatch(changeClientsModal({ addModal: true }));
    }
  };

  const determineAddButtonDisplay = () => {
    if (!activeCompany) {
      return "add-client-button disabled";
    }

    if (activeCompany && !activeCompany.subscription) {
      return "add-client-button disabled";
    }

    return "add-client-button";
  };

  const determineAddButtonClick = () => {
    if (activeCompany && activeCompany.subscription) {
      clickAddNewClient();
    }
  };

  const determineDeleteButtonClick = () => {
    if (deletions && deletions.length > 0) {
      clickDeleteClients();
    }
  };

  const clickDeleteClients = () => {
    dispatch(
      requestDeleteClientArray({
        companyId: activeCompany.id,
        items: deletions,
      })
    );
  };

  const renderMainButtons = () => {
    return [
      <SolidButton
        onClick={() => determineDeleteButtonClick()}
        color="gray"
        spacing="right"
        icon={
          deleteLoading ? (
            <i className="fas fa-circle-notch fa-spin" />
          ) : (
            <i className="fas fa-trash-alt" />
          )
        }
        title={deleteLoading ? "Sletter.." : "Slett kunder"}
      />,
      <SolidButton
        color="blue"
        icon={<i class="fad fa-plus"></i>}
        title="Ny kunde"
        onClick={() => determineAddButtonClick()}
        data-toggle="modal"
        data-target="#addModal"
        className={determineAddButtonDisplay()}
      />,
    ];
  };

  return (
    <section className="dashboard-clients-section">
      <div className="inner-dashboard-clients-container">
        <UpperRow title="Kunder" buttons={renderMainButtons()} />
        <SearchField handleSearch={searchLibrary} />
        <TabSelector defaultValue="companies" items={selectionTabs} />
        {modal.addModal ? <AddClientModal /> : null}
        {modal.editModal ? <EditClientModal /> : null}
        {modal.deleteModal ? <DeleteClientModal /> : null}
      </div>
      <ToastContainer />
    </section>
  );
};

export default Index;
